import type { ReactNode } from 'react';

import { mt } from './messages';

type AbsentKind = 'not_measured' | 'withheld' | 'not_observable' | { text: string };

function isFreeText(reason: AbsentKind): reason is { text: string } {
  return typeof reason === 'object' && reason !== null;
}

export function Absent(props: { reason: AbsentKind }): ReactNode {
  const text = isFreeText(props.reason) ? props.reason.text : mt(`absent.${props.reason}`);
  return (
    <span
      className="text-muted-foreground"
      data-absent={isFreeText(props.reason) ? 'text' : props.reason}
    >
      {/* eslint-disable-next-line no-restricted-syntax -- decorative glyph, aria-hidden; the sr-only span below carries the reason */}
      <span aria-hidden>—</span>
      <span className="sr-only">{text}</span>
    </span>
  );
}
